import { localI18nEn } from './local.en';
import { localI18nPt } from './local.pt';

export const localI18n = {
	pt: localI18nPt,
	en: localI18nEn,
};
